import { useTranslation } from 'react-i18next'

import { Button } from '#/shared/ui/button'
import { PencilIcon, RouteStopsCombinedIcon } from '#/shared/ui/icons'
import { Skeleton } from '#/shared/ui/skeleton'

export function ShipmentCardSkeleton() {
  const { t } = useTranslation()
  return (
    <div className="flex w-full flex-col gap-3.75 rounded-md border border-gray-200 bg-white pt-2.5 pb-5">
      <div className="flex flex-col gap-1.25">
        <div className="flex h-8 items-center justify-between px-5 pb-1.25">
          <h3 className="text-base font-semibold text-gray-900">
            {t('shipmentCard.title')}
          </h3>
          <div className="flex items-center gap-2.5">
            <Button variant="link" size="xxs" disabled>
              {t('shipmentCard.editAll')}
            </Button>
            <button
              type="button"
              aria-label={t('shipmentCard.edit')}
              disabled
              className="flex size-8 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-500 opacity-60"
            >
              <PencilIcon className="size-3.5" />
            </button>
          </div>
        </div>
        <div className="h-px w-full bg-gray-200" />
      </div>

      <div className="flex flex-col">
        <div className="flex h-6 items-center justify-between px-5 text-xs text-gray-500">
          <span className="uppercase">{t('shipmentCard.vehicle')}</span>
          <Skeleton className="h-3 w-16" />
        </div>
        <div className="flex h-8 items-center px-5">
          <div className="flex h-full flex-1 items-center gap-2.5 px-1.25">
            <Skeleton className="h-4 w-48" />
          </div>
        </div>
      </div>

      <div className="flex flex-col">
        <div className="flex h-6 items-center justify-between px-5 text-xs text-gray-500">
          <span className="uppercase">{t('shipmentCard.route')}</span>
          <Skeleton className="h-3 w-24" />
        </div>
        <div className="flex items-center gap-1.5 px-5">
          <RouteStopsCombinedIcon className="h-16 w-5.5 shrink-0 text-gray-200" />
          <div className="flex flex-1 flex-col gap-2.5">
            <Skeleton className="h-6 w-full" />
            <Skeleton className="h-6 w-full" />
          </div>
        </div>
      </div>
    </div>
  )
}
